// extracted by mini-css-extract-plugin
module.exports = {"sizeImg":"buy_sizeImg__2fyH7"};